import classnames from 'classnames';
import * as PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'redux-little-router';
import SIZES from './sizes';
import COLORS from './colors';
import Loading from 'components/Loading';

import styles from './Button.module.scss';

export default class Button extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    isFullWidth: PropTypes.bool,
    hasWrapper: PropTypes.bool,
    size: PropTypes.oneOf(Object.values(SIZES)),
    isDisabled: PropTypes.bool,
    color: PropTypes.oneOf(Object.values(COLORS)),
    value: PropTypes.string,
    type: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    style: PropTypes.object,
    buttonStyle: PropTypes.object,
    extraClassName: PropTypes.string,
    buttonClassNames: PropTypes.string,
    className: PropTypes.string,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isLinkStyled: PropTypes.bool,
    target: PropTypes.string,
    isLoading: PropTypes.bool,
  };
  static defaultProps = {
    hasWrapper: true,
    isDisabled: false,
    size: SIZES.MEDIUM,
    color: COLORS.BLUE,
    isFullWidth: false,
    type: 'submit',
    extraClassName: '',
  };
  static getDerivedStateFromProps(props) {
    if (typeof props.isLoading === 'boolean') {
      return {
        showLoader: props.isLoading,
      };
    }
    return null;
  }

  state = {
    showLoader: this.props.isLoading,
  };

  componentDidMount() {
    this._ismounted = true;
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  getElement() {
    return this.isLink() ? Link : 'button';
  }

  getButtonClassNames() {
    const {
      buttonClassNames,
      size,
      color,
      extraClassName,
      isFullWidth,
      isDisabled,
      isLinkStyled,
    } = this.props;
    const { showLoader } = this.state;
    return buttonClassNames
      ? buttonClassNames
      : classnames(
          styles.button,
          styles[`button__${size}`],
          styles[`button__${color}`],
          extraClassName,
          {
            [styles.button__100]: isFullWidth,
            [styles.button__disable]: isDisabled || showLoader,
            [styles.button__link]: isLinkStyled,
          },
        );
  }

  getComponentProps() {
    const { isDisabled, value, type, href, target } = this.props;
    const { showLoader } = this.state;

    const buttonProps = {
      disabled: isDisabled || showLoader,
      type,
      value,
    };

    const linkProps = {
      href,
      target,
    };

    return this.isLink() ? linkProps : buttonProps;
  }

  getRestProps() {
    const {
      isDisabled,
      size,
      value,
      color,
      type,
      isFullWidth,
      hasWrapper,
      buttonStyle,
      style,
      extraClassName,
      className, // remove React className prop from result object, to prevent class overwrite
      children,
      buttonClassNames,
      isLinkStyled,
      href,
      isLoading,
      onClick,
      ...restProps
    } = this.props;

    return restProps;
  }

  isLink() {
    const { href } = this.props;
    return !!href;
  }

  onClickHandler = async (evt) => {
    const { onClick } = this.props;
    this.setState({ showLoader: true });

    if (typeof onClick === 'function') {
      try {
        await onClick(evt);
      } catch (e) {
        // eslint-disable-next-line
        console.log(e);
      }
    }
    if (this._ismounted) {
      this.setState({ showLoader: false });
    }
  };

  renderButton = () => {
    const { value, buttonStyle, children } = this.props;
    const { showLoader } = this.state;

    const buttonClassName = this.getButtonClassNames();
    const Component = this.getElement();
    const componentProps = this.getComponentProps();
    const restProps = this.getRestProps();
    const isLoaderVisible = showLoader;

    return (
      <Component
        className={buttonClassName}
        style={buttonStyle}
        onClick={this.onClickHandler}
        {...componentProps}
        {...restProps}
      >
        {isLoaderVisible && <Loading />}
        {children || value}
      </Component>
    );
  };

  renderWrapper = () => {
    const { style } = this.props;
    return (
      <div style={style} className="form_buttons">
        {this.renderButton()}
      </div>
    );
  };

  render() {
    const { hasWrapper } = this.props;
    return hasWrapper ? this.renderWrapper() : this.renderButton();
  }
}
